/**
 * Category "line colors". A category owns one slot for life; the color
 * follows the entity, never its rank. Slots beyond 7 fold into Other.
 */
export const SERIES_COUNT = 7;

export function series(slot: number): string {
  if (slot < 1 || slot > SERIES_COUNT) return SERIES_OTHER;
  return `var(--series-${slot})`;
}

export const SERIES_OTHER = 'var(--series-other)';
